import { SPECIAL_PRICE } from '../constants';
import { InitialPublicOfferItem } from '@libs/api-reference';

function offerHasPrice(offer: InitialPublicOfferItem) {
  const isMaxPriceSpecial = offer.maximumOrderPrice === SPECIAL_PRICE;
  const isMinPriceSpecial = offer.minimumOrderPrice === SPECIAL_PRICE;

  return !(isMaxPriceSpecial && isMinPriceSpecial);
}

export { offerHasPrice };
